import React from 'react';
import { Alert, Box } from '@mui/material';
import { defineMessages, useIntl } from 'react-intl';
const msgs = defineMessages({
    errorFailedToLoad: {
        id: 'loader.LoadError.error.failedToLoad',
        defaultMessage: 'Failed to load content.',
    },
});
function LoadError() {
    const intl = useIntl();
    return (React.createElement(Box, null,
        React.createElement(Alert, { severity: "error" }, intl.formatMessage(msgs.errorFailedToLoad))));
}
export default LoadError;
